{
  "loading": "로드 중",
  "placeholder": "선택 사항 선택"
}
